import cn from 'classnames';
import React from 'react';
import { dataroomUrl } from '@dataroom/url';
import DataroomListItem from '../../../domain/DataroomListItem';
import {
  PENDING_REQUESTS_TOOLTIP,
  COUNT_LABEL_BACKGROUND_COLOR,
} from './constants';
import CountLabel from '@dealroadshow/uikit-badge/CountLabel';
import Tooltip from '@dealroadshow/uikit-tooltip';
import styles from '../datarooms.module.scss';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import { IDataroomListItem } from '../../../domain/vo/DataroomListItem';
import config from '@dataroom/config';
import usersUrl from '@users/url';

interface IProps {
  cellProps: {
    row: IDataroomListItem,
    cellTitle?: React.ReactNode,
    countryId?: string | null,
  },
  isDisabled?: boolean,
}

const UsersCell = ({ cellProps, isDisabled = false }: IProps) => {
  const { tenant } = useDataroomTenantContext();
  const {
    row: dataroom,
    cellTitle,
  } = cellProps;
  const isDataroomDisabled = DataroomListItem.isDataroomDisabled(dataroom);
  const { tenantUrlPrefix } = config[tenant].options;

  return (
    <span
      className={ cn(
        styles.usersCount,
        isDataroomDisabled && styles.deactivatedDataroom,
        isDisabled && styles.columnDisable,
      ) }
    >
      <span className={ styles.mobileColName }>{ cellTitle }</span>
      <span>{ dataroom.usersCount?.toLocaleString() || '-' }</span>
      { !isDataroomDisabled && !!dataroom.pendingAccessRequestsCount && (
        <Tooltip
          content={ PENDING_REQUESTS_TOOLTIP }
          wrpClassName={ styles.wrpCountLabel }
        >
          <a
            href={ usersUrl.getSessionPropagateUrl(dataroomUrl(tenant)
              .getUrl(`/${ tenantUrlPrefix }/${ dataroom.name }/settings/manage-access-requests/pending`)) }
          >
            <CountLabel
              canShowCount={ !!dataroom.pendingAccessRequestsCount }
              className={ styles.countLabel }
              totalCount={ dataroom.pendingAccessRequestsCount }
              maxTotalCount={ 9 }
              backgroundColor={ COUNT_LABEL_BACKGROUND_COLOR }
            />
          </a>
        </Tooltip>
      ) }
    </span>
  );
};

export default UsersCell;
